/**
 * ToolbarSelect Component
 *
 * Native select element for toolbar options.
 */

export interface ToolbarSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
}

export function ToolbarSelect({ value, onChange, options }: ToolbarSelectProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="bg-surface-tertiary/50 border border-border-primary rounded-lg px-2 py-1 text-[10px] sm:px-2.5 sm:py-1.5 sm:text-[11px] text-text-secondary font-medium focus:outline-none focus:border-accent-violet/50 cursor-pointer hover:bg-surface-tertiary transition-colors"
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
